var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("cart-template", {
    attrs: {
      canBack: !_vm.isSourceSale,
      hasAlert: _vm.isSourceSale,
      isPlan: _vm.isPlanPath
    },
    scopedSlots: _vm._u([
      {
        key: "configuration",
        fn: function() {
          return [
            _c("cart-navigation", {
              attrs: { smallMargin: _vm.isSourceSale, context: "client" }
            }),
            _vm._v(" "),
            _vm.isSourceSale && !_vm.isPaymentPath
              ? _c("expiration-message", {
                  attrs: { expirationDate: _vm.expirationDate }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-form",
              {
                ref: "clientCartForm",
                attrs: {
                  "label-position": "top",
                  rules: _vm.setRules,
                  model: _vm.modelForm
                }
              },
              [_c("router-view", { attrs: { store: "client" } })],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "resume",
        fn: function() {
          return [
            _c("cart-summary", {
              attrs: { context: "client" },
              scopedSlots: _vm._u([
                {
                  key: "licences",
                  fn: function() {
                    return [
                      _c(
                        "ul",
                        { staticClass: "ov-auto mb-0 cart-recap-products" },
                        [
                          _vm._l(_vm.productsWithLicences, function(
                            product,
                            index
                          ) {
                            return _c(
                              "li",
                              {
                                key: product.code,
                                ref: "products-summary",
                                refInFor: true,
                                staticClass: "flex-row",
                                class: {
                                  "mb-2":
                                    index + 1 !==
                                    _vm.productsWithLicences.length
                                }
                              },
                              [
                                _c("div", [
                                  _c(
                                    "p",
                                    {
                                      ref: "product-quantity-summary",
                                      refInFor: true,
                                      staticClass: "grey m-0 fs-3"
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$l10n.n__(
                                              "%(total)s licence %(productsName)s",
                                              "%(total)s licences %(productsName)s",
                                              _vm.products[product.id].quantity,
                                              {
                                                total:
                                                  _vm.products[product.id]
                                                    .quantity,
                                                productsName: product.title
                                              }
                                            )
                                          ) +
                                          "\n                            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.freeLicencesByProduct(product.id)
                                    ? _c(
                                        "span",
                                        {
                                          ref: "free-quantity-summary",
                                          refInFor: true,
                                          staticClass: "grey"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$l10n.n__(
                                                "Dont %s offerte",
                                                "Dont %s offertes",
                                                _vm.freeLicencesByProduct(
                                                  product.id
                                                ),
                                                _vm.freeLicencesByProduct(
                                                  product.id
                                                )
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _vm.products[product.id].total
                                  ? [
                                      _vm.freeLicencesByProduct(product.id)
                                        ? _c(
                                            "p",
                                            {
                                              ref:
                                                "product-discount-total-summary",
                                              refInFor: true,
                                              staticClass:
                                                "flex-item-right my-0"
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "strike grey semibold"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        _vm.$filters.numberFormatToFloatWithOptions(
                                                          _vm.products[
                                                            product.id
                                                          ].total.monthly
                                                            .total_amount
                                                        )
                                                      ) +
                                                      "\n                                "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "success-50 fs-3 pl-2 semibold"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                    " +
                                                      _vm._s(
                                                        _vm.$filters.numberFormatToFloatWithOptions(
                                                          _vm.products[
                                                            product.id
                                                          ].total.monthly
                                                            .total_amount_discounted,
                                                          _vm.numformat,
                                                          true
                                                        )
                                                      )
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "fs-2" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$l10n.__("/mois")
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "p",
                                            {
                                              ref: "product-total-summary",
                                              refInFor: true,
                                              staticClass:
                                                "flex-item-right my-0 fs-3 semibold grey"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(
                                                    _vm.$filters.numberFormatToFloatWithOptions(
                                                      _vm.products[product.id]
                                                        .total.monthly
                                                        .total_amount_discounted,
                                                      _vm.numformat,
                                                      true
                                                    )
                                                  )
                                              ),
                                              _c(
                                                "span",
                                                { staticClass: "fs-2" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$l10n.__("/mois")
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          }),
                          _vm._v(" "),
                          _vm._l(
                            _vm.packsWithLicences.concat(
                              _vm.groupedPacksWithLicences
                            ),
                            function(product, index) {
                              return _c(
                                "li",
                                {
                                  key: product.code,
                                  ref: "packs-summary",
                                  refInFor: true,
                                  staticClass: "flex-row",
                                  class: {
                                    "mb-2":
                                      index + 1 !==
                                      _vm.packsWithLicences.concat(
                                        _vm.groupedPacksWithLicences
                                      ).length,
                                    "mt-2": index === 0
                                  }
                                },
                                [
                                  _c("div", [
                                    _c("p", { staticClass: "grey m-0 fs-3" }, [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$l10n.__(
                                              "Module %(productsName)s",
                                              {
                                                productsName: !!product.groups
                                                  .length
                                                  ? product.printableName
                                                  : product.title
                                              }
                                            )
                                          ) +
                                          "\n                            "
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _vm.products[product.id].total
                                    ? [
                                        _vm.products[product.id].total.monthly
                                          .total_amount_discounted <
                                        _vm.products[product.id].total.monthly
                                          .total_amount
                                          ? _c(
                                              "p",
                                              {
                                                ref:
                                                  "packs-total-discount-summary",
                                                refInFor: true,
                                                staticClass:
                                                  "flex-item-right my-0 semibold"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "strike grey semibold"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          _vm.$filters.numberFormatToFloatWithOptions(
                                                            _vm.products[
                                                              product.id
                                                            ].total.monthly
                                                              .total_amount,
                                                            _vm.numformat,
                                                            true
                                                          )
                                                        ) +
                                                        "\n                                "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "success-50 fs-3 pl-2"
                                                  },
                                                  [
                                                    _vm.products[product.id]
                                                      .total.monthly
                                                      .total_amount_discounted !==
                                                    0
                                                      ? [
                                                          _vm._v(
                                                            "\n                                        " +
                                                              _vm._s(
                                                                _vm.$filters.numberFormatToFloatWithOptions(
                                                                  _vm.products[
                                                                    product.id
                                                                  ].total
                                                                    .monthly
                                                                    .total_amount_discounted,
                                                                  _vm.numformat,
                                                                  true
                                                                )
                                                              )
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "fs-2"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$l10n.__(
                                                                    "/mois"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      : [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$l10n.__(
                                                                "Offert"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                  ],
                                                  2
                                                )
                                              ]
                                            )
                                          : _c(
                                              "p",
                                              {
                                                ref: "packs-total-summary",
                                                refInFor: true,
                                                staticClass:
                                                  "flex-item-right my-0 fs-3 semibold grey"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                *\n                                " +
                                                    _vm._s(
                                                      _vm.$filters.numberFormatToFloatWithOptions(
                                                        _vm.products[product.id]
                                                          .total.monthly
                                                          .total_amount_discounted,
                                                        _vm.numformat,
                                                        true
                                                      )
                                                    )
                                                ),
                                                _c(
                                                  "span",
                                                  { staticClass: "fs-2" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$l10n.__("/mois")
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            }
                          )
                        ],
                        2
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "subtotal",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "flex-column fs-3 cart-recap-total-label"
                        },
                        [
                          _c("span", { staticClass: "mb-2" }, [
                            _vm._v(_vm._s(_vm.$l10n.__("Sous-total")))
                          ]),
                          _vm._v(" "),
                          _vm.taxRate && _vm.taxRate !== 0
                            ? _c("span", { staticClass: "mb-2" }, [
                                _vm._v(
                                  _vm._s(_vm.$l10n.__("TVA")) +
                                    " " +
                                    _vm._s(_vm.taxRate) +
                                    "%"
                                )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isYearly
                        ? _c(
                            "div",
                            {
                              ref: "subtotal-summary-yearly",
                              staticClass: "flex-column aright fs-3"
                            },
                            [
                              _c("span", { staticClass: "semibold mb-2" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$filters.numberFormatToFloatWithOptions(
                                        _vm.totalYearly.total_amount_discounted,
                                        _vm.numformat,
                                        true
                                      )
                                    )
                                ),
                                _c("span", { staticClass: "fs-2" }, [
                                  _vm._v(_vm._s(_vm.$l10n.__("/an")))
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.taxRate && _vm.taxRate !== 0
                                ? _c("span", { staticClass: "semibold mb-2" }, [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$filters.numberFormatToFloatWithOptions(
                                            _vm.totalYearly.total_amount_vat,
                                            _vm.numformat,
                                            true
                                          )
                                        ) +
                                        "\n                    "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isMonthly
                        ? _c(
                            "div",
                            {
                              ref: "subtotal-summary-monthly",
                              staticClass: "flex-column aright fs-3"
                            },
                            [
                              _c("span", { staticClass: "semibold mb-2" }, [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$filters.numberFormatToFloatWithOptions(
                                        _vm.totalMonthly
                                          .total_amount_discounted,
                                        _vm.numformat,
                                        true
                                      )
                                    )
                                ),
                                _c("span", { staticClass: "fs-2" }, [
                                  _vm._v(_vm._s(_vm.$l10n.__("/mois")))
                                ])
                              ]),
                              _vm._v(" "),
                              _vm.taxRate && _vm.taxRate !== 0
                                ? _c("span", { staticClass: "semibold mb-2" }, [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$filters.numberFormatToFloatWithOptions(
                                            _vm.totalMonthly.total_amount_vat,
                                            _vm.numformat,
                                            true
                                          )
                                        ) +
                                        "\n                    "
                                    )
                                  ])
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ]
                  },
                  proxy: true
                },
                {
                  key: "total",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        {
                          ref: "summary-total",
                          staticClass: "flex-row jc-space",
                          class: { "mb-4": !_vm.isPaymentPath }
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "fs-4 my-0 bold cart-recap-total-label"
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$l10n.__("Total TTC")) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isYearly
                            ? _c(
                                "p",
                                { staticClass: "fs-4 my-0 aright bold" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$filters.numberFormatToFloatWithOptions(
                                          _vm.totalYearly
                                            .total_amount_tax_included,
                                          _vm.numformat,
                                          true
                                        )
                                      )
                                  ),
                                  _c("span", { staticClass: "fs-2" }, [
                                    _vm._v(_vm._s(_vm.$l10n.__("/an")))
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isMonthly
                            ? _c(
                                "p",
                                { staticClass: "fs-4 my-0 aright bold" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$filters.numberFormatToFloatWithOptions(
                                          _vm.totalMonthly
                                            .total_amount_tax_included,
                                          _vm.numformat,
                                          true
                                        )
                                      )
                                  ),
                                  _c("span", { staticClass: "fs-2" }, [
                                    _vm._v(_vm._s(_vm.$l10n.__("/mois")))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "actions",
                  fn: function() {
                    return [
                      _vm.isPaymentPath
                        ? [
                            _c("span", { staticClass: "separator block my-3" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex-row terms mb-4" },
                              [
                                _c("el-checkbox", {
                                  model: {
                                    value: _vm.cguv,
                                    callback: function($$v) {
                                      _vm.cguv = $$v
                                    },
                                    expression: "cguv"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "ml-2 fs-3",
                                  domProps: { innerHTML: _vm._s(_vm.cguvLink) }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("CompassButton", {
                        ref: "form-submit",
                        staticClass: "wp-10",
                        attrs: {
                          label: _vm.labelButton,
                          type: "primary",
                          disabled:
                            (!_vm.cguv && _vm.isPaymentPath) ||
                            _vm.computeLoading,
                          loading: _vm.computeLoading
                        },
                        on: {
                          click: function($event) {
                            return _vm.submitForm(
                              "clientCartForm",
                              "nextAction"
                            )
                          }
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }